import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import SessionManager from "@/apollo/datasources/sessionManager";
import config from "@/lib/config";
import connectRedis from "@/lib/connectRedis";
import Cookies from "@/lib/cookies";
import dayjs from "@/lib/day";
import { AuthenticationError } from "apollo-server-errors";
import { createHash } from "crypto";
import jwt from "jsonwebtoken";
export default class UserToken {
  constructor(req, res) {
    var _config$token$redis, _config$token$redis2, _config$token$redis3, _config$token;
    this.req = req;
    this.res = res;
    this.cookies = new Cookies(req, res);
    this.redis = connectRedis({
      host: process.env.REDIS_HOST || ((_config$token$redis = config.token.redis) === null || _config$token$redis === void 0 ? void 0 : _config$token$redis.host),
      port: process.env.REDIS_PORT || ((_config$token$redis2 = config.token.redis) === null || _config$token$redis2 === void 0 ? void 0 : _config$token$redis2.port),
      keyPrefix: config.token.redis.prefix,
      db: (_config$token$redis3 = config.token.redis) === null || _config$token$redis3 === void 0 ? void 0 : _config$token$redis3.db
    }, (_config$token = config.token) === null || _config$token === void 0 || (_config$token = _config$token.redis) === null || _config$token === void 0 ? void 0 : _config$token.cluster);
  }
  get cookieName() {
    return config.token.name;
  }
  getToken() {
    return this.cookies.get(this.cookieName);
  }
  get signatureName() {
    return config.token.signature;
  }
  getSignature() {
    return this.cookies.get(this.signatureName);
  }
  getSecret() {
    let signature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (!signature) {
      signature = this.getSignature();
    }
    return `${signature}${config.token.secret}`;
  }
  generateKey(id, signature) {
    const key = (() => {
      return `token:${id}:${signature}`;
    })();
    return createHash("sha256").update(key).digest("hex");
  }
  async setPayload(payload, signature) {
    const key = this.generateKey(payload.id, signature);
    await this.redis.multi().set(key, JSON.stringify(payload)).expire(key, config.token.maxAge).exec();
    return key;
  }
  async getPayload(key) {
    const json = await this.redis.get(key);
    return JSON.parse(json);
  }
  deletePayload(key) {
    return this.redis.del(key);
  }
  async sign(payload, signature) {
    if (!signature) {
      signature = this.getSignature();
    }
    const key = await this.setPayload(payload, signature);
    const secret = this.getSecret(signature);
    const token = jwt.sign({
      key
    }, secret);
    const options = {
      maxAge: config.token.maxAge
    };
    // remembermeのon/offがあったらこっちにする
    // let options = {};
    // if (payload.rememberme) {
    //   options = {
    //     maxAge: config.token.maxAge,
    //   };
    // }
    this.cookies.set([{
      name: this.signatureName,
      value: signature,
      options
    }, {
      name: this.cookieName,
      value: token,
      options
    }]);
    return token;
  }
  async refreshToken() {
    try {
      const sessionManager = new SessionManager({
        req: this.req,
        res: this.res
      });
      const ret = await sessionManager.tokenRefresh();
      // リフレッシュしたら古いトークンを明示的に削除したほうがいいかもしれないが、複数のリクエストが来ていた時にエラーするかもしれない
      // const delRet = await sessionManager.tokenDelete();
      // console.log("old token delete", delRet);
      return {
        accessToken: ret.access_token,
        refreshToken: ret.refresh_token,
        tokenExpiredAt: dayjs().add(ret.expires_in, "second").format()
      };
    } catch (e) {
      // if (e instanceof AuthenticationError) {
      //   if (token.payload.rememberme) {
      //     const rememberme = new Rememberme();
      //     const remembermeData = await rememberme.get(token.payload.id);
      //     if (remembermeData) {
      //       const user = new User();
      //       user.initialize({ context: { req: this.req, res: this.res } });
      //       const ret = await user.login(
      //         remembermeData.loginid,
      //         remembermeData.password
      //       );
      //       rememberme.refresh(token.payload.id);
      //       return {
      //         accessToken: ret.access_token,
      //         refreshToken: ret.refresh_token,
      //         tokenExpiredAt: dayjs().add(ret.expires_in, "second").format(),
      //       };
      //     }
      //   }
      // }
      console.log("tokenRefresh Error:", e);
      console.log(e === null || e === void 0 ? void 0 : e.extension);
      this.delete();
      throw new AuthenticationError("Unauthorized");
    }
  }
  async refresh() {
    let updatePayload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const token = await this.verify();
    if (!token) return null;
    delete token.iat;
    delete token.exp;
    delete token.nbf;
    delete token.jti;
    // アクセストークンのexpireが近かったらリフレッシュする
    let refreshPayload = {};
    if (
    // tokenが発行した時刻から15分以上経過していればリフレッシュする
    dayjs(token.payload.tokenExpiredAt).isBefore(dayjs().add(15, "minutes"))) {
      refreshPayload = await this.refreshToken();
    }
    const newPayload = Object.assign({}, token.payload, updatePayload, refreshPayload);
    await this.sign(newPayload);
    return newPayload;
  }

  // LOGICAトークン失効判定
  // 返却値 トークン失効: false, トークン有効: true
  async checkExpiration() {
    const token = await this.verify();
    if (!token) return false;
    return dayjs(token.payload.tokenExpiredAt).isAfter(dayjs());
  }
  async verify() {
    // cookieからtokenを取得
    const token = this.getToken();
    if (!token) return false;
    // cookieからsignatureを取得
    const secret = this.getSecret();
    // tokenを検証
    const verifiedToken = jwt.verify(token, secret);
    // redisからpayloadを取得
    const payload = await this.getPayload(verifiedToken.key);
    if (!payload) return false;
    return _objectSpread(_objectSpread({}, verifiedToken), {}, {
      payload
    });
  }
  async delete() {
    const token = this.getToken();
    if (!token) {
      console.log("userToken delete, token not found");
      return false;
    }
    try {
      const secret = this.getSecret();
      const verifiedToken = jwt.verify(token, secret);
      await this.deletePayload(verifiedToken.key);
    } catch (e) {
      console.log("token delete error", e);
    } finally {
      this.cookies.remove([this.cookieName, this.signatureName, [config.optionalTermsConfirmCookieName, {
        domain: null
      }]]);
    }
  }
  async deleteAll() {
    const removeCookies = [[config.optionalTermsConfirmCookieName, {
      domain: null
    }]];
    try {
      [true, false].forEach(async val => {
        const token = this.getToken();
        if (token) {
          const secret = this.getSecret();
          const verifiedToken = jwt.verify(token, secret);
          removeCookies.push(this.cookieName);
          removeCookies.push(this.signatureName);
          await this.deletePayload(verifiedToken.key);
        }
      });
    } catch (e) {
      console.log("token delete error", e);
    } finally {
      this.cookies.remove(removeCookies);
    }
  }
}